import { createStore, applyMiddleware } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import thunk from "redux-thunk";
import AsyncStorage from "@react-native-async-storage/async-storage";

import rootReducer from "./reducers";

import { composeWithDevTools } from "redux-devtools-extension";

const persistConfig = {
  // key: "anzaraltd",
  // key: "azranltd",
  // key: "elorltd",
  key: "accouting",
  storage: AsyncStorage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const middleware = [thunk];

let store = createStore(
  persistedReducer,
  composeWithDevTools(applyMiddleware(...middleware))
);
let persistor = persistStore(store);
export { store, persistor };
